import type { NavigateFunction } from 'react-router-dom';

export const PRIVACY_POLICY_IDS = [
  'distributor-privacy-terms',
  'orbo-privacy',
  'herbalife-privacy',
  'data-privacy-terms',
] as const;

export type PrivacyPolicyId = (typeof PRIVACY_POLICY_IDS)[number];

export const PRIVACY_POLICY_RETURN_PATH_KEY = 'privacyPolicyReturnPath';

const LEGACY_POLICY_ALIASES: Record<string, PrivacyPolicyId> = {
  'hlskin-terms': 'data-privacy-terms',
  'distributor-privacy': 'distributor-privacy-terms',
};

export const resolvePrivacyPolicyId = (
  value: string | null | undefined,
): PrivacyPolicyId | false => {
  if (!value) return false;

  if (PRIVACY_POLICY_IDS.includes(value as PrivacyPolicyId)) {
    return value as PrivacyPolicyId;
  }

  return LEGACY_POLICY_ALIASES[value] ?? false;
};

export const buildPrivacyPolicyUrl = (
  policyId: PrivacyPolicyId | string,
): string => {
  const params = new URLSearchParams({ privacy: policyId });
  return `/privacy-policy?${params.toString()}`;
};

export const openPrivacyPolicy = (
  navigate: NavigateFunction,
  policyId: PrivacyPolicyId | string,
  returnPath: string,
): void => {
  sessionStorage.setItem(PRIVACY_POLICY_RETURN_PATH_KEY, returnPath);
  navigate(buildPrivacyPolicyUrl(policyId));
};
